import axios, { AxiosInstance } from 'axios';
import store from '@/store';
import {Jwt} from '@/assets/ts/jwt';

class ApiInstance {

    private static _instance: ApiInstance;

    protected http: AxiosInstance;

    private constructor() {
        this.http = axios.create({
            baseURL: process.env.VUE_APP_API,
        });
        this.http.interceptors.request.use((config) => {
            const jwt = new Jwt(store.getters.authToken);
            const url = config.url || '';
            if (!url.includes('sign-in') && jwt.isExpired()) {
                return store.dispatch('AUTH_REFRESH').then(() => {
                    return Promise.resolve(config);
                });
            } else {
                return Promise.resolve(config);
            }
        });
    }

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    public setAuthorizationHeader(token: string) {
        this.http.defaults.headers.common.Authorization = 'Bearer ' + token;
    }

    public signIn(username: string, password: string) {
        return this.http.post('/v1/sign-in',
        {username, password});
    }

    public getMe() {
        return this.http.get('/v1/users/me');
    }

    public refreshAuthToken(refeshToken: string) {
        return this.http.post('/v1/sign-in/refresh', {refresh_token: refeshToken});
    }

    public updateMe(data: object) {
        return this.http.post('/v1/users/me', data);
    }

    public getOwnMailinglists() {
        return this.http.get('/v1/users/me/mailinglists');
    }

    public subscribeToMailinglist(name: string) {
        return this.http.put('/v1/users/me/mailinglists/' + name);
    }

    public unsubscribeFromMailinglist(name: string) {
        return this.http.delete('/v1/users/me/mailinglists/' + name);
    }

    public changePassword(currentPassword: string, newPassword: string, repeat: string) {
        return this.http.post('/v1/users/me/password',
        {current_password: currentPassword, new_password: newPassword, repeat});
    }

    public changeMail(mail: string) {
        return this.http.post('/v1/users/me/changemail', {new_mail: mail});
    }
}

export const API = ApiInstance.Instance;
